import * as AdType from 'common/constants/ad-type';
import * as ShowType from 'show-page/constants/show-type';
import * as VideoType from 'common/constants/video-type';
import Environment from 'common/utils/environment';
import { action, computed, observable } from 'mobx';
import { debounce } from 'lodash';


class AdManager {
    @observable playerAdRunning = false;
    @observable processedRegistry = false;

    constructor(showStore, uiStore) {
        this.showStore = showStore;
        this.uiStore = uiStore;
        this.playerAdRunning = !!this.showStore.sluggedVideo;
    }

    destroy() {
        this.showStore = null;
        this.uiStore = null;
    }

    refreshAllAds = debounce(() => {
        AMPTManager.refreshAllAds();
    }, 400);

    @computed get adType() {
        if (!this.playerAdRunning || Environment.mobile || this.uiStore.viewportWidth < 970) {
            return AdType.DFP;
        }
        const { selectedVideo, type } = this.showStore;
        if (selectedVideo && (type === ShowType.DOTCOM || selectedVideo.type === VideoType.EPISODE || selectedVideo.auth)) {
            return AdType.FREEWHEEL;
        }
        return AdType.DFP;
    }

    @action processRegistry = () => {
        AMPTManager.processNewRegistry(this.showStore.adRegistryUrl);
        this.processedRegistry = true;
    };

    @action setPlayerAdState = (started, e) => {
        // Always true on postroll start and end so dfp doesn't render between following preroll
        if (e && e.adType === AdType.VIDEO_POSTROLL) {
            this.playerAdRunning = true;
            return;
        }
        this.playerAdRunning = !!started;
    };

}


export default AdManager;



// WEBPACK FOOTER //
// ./src/show-page/stores/ad-manager.js